import { useQueryClient } from '@tanstack/react-query';

import { useMutation, useQuery } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { editByUserOrganisationProfile, getByUserOrganisationProfile } from '@api/settings';

import { extractQueryParams } from '@utils/common';

import { IOrganisationFormDTO } from '@interfaces/organisation/dto/organisationsDTO';

import { ESnackbarTypes } from '@enums/common';

import { SETTINGS } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useSettings = () => {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const {
		data,
		isLoading: isLoadingProfile,
		isFetching: isFetchingProfile,
	} = useQuery({
			queryKey: [SETTINGS],
			queryFn: extractQueryParams(getByUserOrganisationProfile),
		},
	);

	const {
		mutate: handleUpdateOrganisation,
		isLoading: isLoadingUpdateOrganisation,
	} = useMutation({
		mutationKey: [SETTINGS],
		mutationFn: async ({ id, values, closeModals }: {
			id?: string;
			values?: IOrganisationFormDTO;
			closeModals?: () => void;
		}) => {
			const data = await editByUserOrganisationProfile({ id, values });

			if (closeModals) {
				closeModals();
			}

			return data;
		},
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.updatedOrganisation,
				type: ESnackbarTypes.success,
			}));

			return queryClient.invalidateQueries([SETTINGS]);
		},
	});

	return {
		profile: data || {},
		handleUpdateOrganisation,
		isLoadingProfile: isLoadingProfile && isFetchingProfile,
		isLoadingUpdateOrganisation,
	};
};

